<template>
  <div class="container-table-striped">
    <div class="table-hover">
      <table class="table content-table-striped table-striped mb-5">
        <thead scope="row">
          <tr class="row global-thead-dark thead-property pl-1">
            <th class="col-4">
              Necesidades
            </th>
          </tr>
        </thead>
        <tbody>
          <tr class="row pl-2">
            <td class="col-md-12 pl-3">
              <div id="accordionMeasurement">
                <div class="card-pei">
                  <div class="card-header">
                    <div class="mb-0">
                      <div
                        data-toggle="collapse"
                        data-target="#collapseOne"
                        aria-expanded="true"
                        aria-controls="collapseOne"
                      >
                        <div class="accordion-header-container">
                          <BadgeModal
                            i="fas fa-plus orange-icon"
                            title="Añadir Necesidades"
                          />
                          <span
                            class="close-border p-1 mr-2 mt-0 float-right"
                            @click="close"
                          >
                            <em class="fas fa-window-close close-ico" />
                            Cerrar
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    id="collapseOne"
                    class="collapse show"
                    aria-labelledby="headingOne"
                    data-parent="#accordionMeasurement"
                  >
                    <div class="card-body">
                      <div class="col-12">
                        <MultiSelectionPicker
                          :all-items="needsTypeList"
                          :selected-items="added"
                          item-type-name="Objeto"
                          :modify-removes-item="true"
                          placeholder="Escriba aquí para buscar una necesidad del estudiante"
                          id-prop-name="id"
                          text-prop-name="name"
                        />
                      </div>
                      <WarningBox
                        class="ml-3 mt-3"
                        title="Puede seleccionar una(1) o más necesidades. Selección múltiple."
                        inline
                      />
                      <div class="col-12">
                        <h6 class="text-muted">
                          Necesidades seleccionadas
                        </h6>
                        <div class="panel">
                          <BadgeTitle
                            v-for="item in added"
                            :key="item.id"
                            :title="item.name"
                            :has-icon="false"
                            :highlight="true"
                            @delete="deleteBadgeTitleHandler(item)"
                          />
                        </div>
                      </div>
                      <div v-show="levelValidationRequiered" class="col-3 mt-3">
                        <ValidationObserver ref="formValidator" class="w-100">
                          <ValidationProvider
                            v-slot="{ errors }"
                            :rules="levelValidationRequiered ? 'required' : ''"
                          >
                            <CustomDropDown
                              v-model="interpeterLevelListSelected"
                              placeholder="Nivel del Intérprete"
                              :disabled="false"
                              :clearable="false"
                              fieldkey="id"
                              fieldname="name"
                              :options="interpeterLevelList"
                              :error="errors[0]"
                              custom-error-msg="Favor seleccionar un nivel"
                              @input="changeIntepterlevel($event)"
                            />
                          </ValidationProvider>
                        </ValidationObserver>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="float-right mt-4">
                <ActionButton
                  class="btn btn-green success float-right mr-2"
                  i="fas fa-save pr-2"
                  type="button"
                  @click="save()"
                >
                  Guardar
                </ActionButton>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import MultiSelectionPicker from '@/components/common/MultiSelectionPicker';
import BadgeModal from '@/components/common/page/badge/BadgeModal';
import { BadgeTitle } from '@/components/pei/shared';
import WarningBox from '@/components/pei/tabs/components/tab8/WarningBox';
import ActionButton from '@/components/common/ActionButton';
import CustomDropDown from '@/components/common/CustomDropDown';
import peiServiceNeeds from "@/utils/constants/pei/peiServiceNeeds.js";

const CommunicationOptions = [
  peiServiceNeeds.Communication,
  peiServiceNeeds.CommunicationV2
];

export default {
  name: 'NeedsStudentAdd',
  data() {
    return {
      added: [],
      interpeterLevelListSelected: null,
      levelValidationRequiered: false,
    };
  },
  props: {
    needsTypeList: {
      type: Array,
      default: () => [],
      required: true,
    },
    selectedInterpreter: {
      type: Number,
      default: () => 0,
      required: false,
    },
    interpeterLevelList: {
      type: Array,
      default: () => [],
      required: true,
    },
    isDraft: {
      type: Boolean,
      required: true,
    },
    activateAssistantServiceNeedGuideParam: {
      type: Boolean,
      required: true,
    },
  },
  watch: {
    added: {
      immediate: true,
      handler(val) {
        let _communicationOptions = CommunicationOptions;

        if (this.activateAssistantServiceNeedGuideParam) {
          _communicationOptions = _communicationOptions.filter(option => option !== peiServiceNeeds.CommunicationV2);
        }
        
        if (val.some((x) => _communicationOptions.includes(x.id))) {
          this.levelValidationRequiered = true;
        } else {
          this.levelValidationRequiered = false;
        }
      },
    },
  },
  mounted() {
    if (this.selectedInterpreter > 0) {
      this.interpeterLevelListSelected = this.interpeterLevelList.find(
        (x) => x.id == this.selectedInterpreter
      );
    }
  },
  methods: {
    deleteBadgeTitleHandler(item) {
      this.added.splice(this.added.indexOf(item), 1);
      this.$emit('delete', item);
    },
    async save() {
      const isValid = await this.$refs.formValidator.validate();
      if (!isValid) {
        return;
      }
      this.$emit('save');
    },
    close() {
      this.$emit('close');
    },
    changeIntepterlevel(event) {
      this.interpeterLevelListSelected = event;
    },
  },
  components: {
    MultiSelectionPicker,
    BadgeModal,
    BadgeTitle,
    WarningBox,
    ActionButton,
    CustomDropDown,
  },
};
</script>

<style scoped>
.thead-property {
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 5px 5px 0px 0px;
}

.close-border {
  border: 1px solid #2db782;
  border-radius: 50px;
  display: inline-block;
  font-family: 'Lato', sans-serif;
  font-weight: 400;
  font-size: 1.125rem;
  line-height: 1.6em;
  text-align: center;
  width: 7.1875rem;
  height: 2.6875‬rem;
  cursor: pointer;
  color: #2db782;
}

.accommodation-box {
  background: #fafbfa 0% 0% no-repeat padding-box;
  border-radius: 0px 5px 5px 0px;
  opacity: 1;
  margin-top: 40px;
}

.multiple-selection-title {
  text-align: left;
  font: Regular 14px/21px Lato;
  letter-spacing: 0;
  color: #b5c3bc;
  opacity: 1;
}

.alert-warning {
  background: #fff5e8 0% 0% no-repeat padding-box;
  border: 1px solid #fdac41;
  border-radius: 4px;
  opacity: 1;
}

.alert-icon {
  float: left;
  padding-top: 0.75%;
}

.alert-content {
  margin-left: 1.5%;
}

.alert span {
  text-align: left;
  font-family: 'Lato', sans-serif;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0;
  color: #af6708;
  display: inline-grid;
}
</style>
